const getters = {
    getAppStatus: (state) => {
        let appstatus = _.first( _.toArray(state.appstatus));
        return appstatus ? appstatus : {};
      },
}

export default getters